import { useEffect } from "react";

interface UseKeyboardNavigationProps<T> {
  flatItems: { item: T; group: string }[];
  activeIndex: number | null;
  setActiveIndex: (index: number | null | ((prev: number | null) => number | null)) => void;
  onSelect: (item: T, group: string) => void;
  clearQuery: () => void;
}

export function useKeyboardNavigation<T>({
  flatItems,
  activeIndex,
  setActiveIndex,
  onSelect,
  clearQuery,
}: UseKeyboardNavigationProps<T>) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "ArrowDown") {
        event.preventDefault();
        setActiveIndex((prev) => (prev === null ? 0 : (prev + 1) % flatItems.length));
      }

      if (event.key === "ArrowUp") {
        event.preventDefault();
        setActiveIndex((prev) =>
          prev === null ? flatItems.length - 1 : (prev - 1 + flatItems.length) % flatItems.length
        );
      }

      if (event.key === "Enter") {
        if (activeIndex !== null) {
          const { item, group } = flatItems[activeIndex];
          onSelect(item, group);
        }
      }

      if (event.key === "Escape") {
        clearQuery();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [flatItems, activeIndex, onSelect, clearQuery, setActiveIndex]);
}
